<template>
    <div>
        <section class="py-8 py-md-11">
            <div class="container">
                <div class="row">
                    <div class="col-12 text-center mb-5">
                        <h2 class="mb-0">
                            Our Products
                        </h2>
                        <p class="lead mb-7 text-center text-muted">

                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section class="pt-0 pt-md-0">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="card card-row shadow-light-lg mb-6 lift lift-lg" id="truvito">
                            <div class="row no-gutters">
                                <a class="col-12 col-md-6 order-md-2 bg-cover card-img-right truvito" href="#!">
                                    <img alt="..." class="img-fluid d-md-none invisible" src="../../assets/img/1c.png">
                                    <div class="shape shape-left shape-fluid-y svg-shim text-white d-none d-md-block">
                                        <svg fill="none" viewBox="0 0 112 690" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.14577e-06 0H62.7586V172C38.6207 384 112 517 112 517V690H2.14577e-06V0Z" fill="currentColor"/>
                                        </svg>
                                    </div>
                                </a>

                                <div class="col-12 col-md-6 order-md-1">
                                    <a class="card-body tab-body" href="#!">
                                        <h2 class="font-weight-bold">
                                            TruVito Audits
                                        </h2>
                                        <ul class="list-unstyled mb-7">
                                            <li class="d-flex">
                                                <div class="badge badge-rounded-circle badge-success-soft mt-1 mr-4">
                                                    <i class="fe fe-check"></i>
                                                </div>
                                                <p>
                                                    Decentralized audit platform that enables stakeholders to confidentially access provenance information directly, thereby eliminating information asymmetry.
                                                </p>
                                            </li>
                                            <li class="d-flex">
                                                <div class="badge badge-rounded-circle badge-success-soft mt-1 mr-4">
                                                    <i class="fe fe-check"></i>
                                                </div>
                                                <p>
                                                    Customizable and configurable audits to enable auditors leverage platform for a complete audit suite including surveillance, compliance, verification and production audits.
                                                </p>
                                            </li>
                                            <li class="d-flex">
                                                <div class="badge badge-rounded-circle badge-success-soft mt-1 mr-4">
                                                    <i class="fe fe-check"></i>
                                                </div>
                                                <p>
                                                    Real-time tracking of audits on Borlaug Blockchain.
                                                </p>
                                            </li>
                                            <li class="d-flex">
                                                <div class="badge badge-rounded-circle badge-success-soft mt-1 mr-4">
                                                    <i class="fe fe-check"></i>
                                                </div>
                                                <p>
                                                    Enables sustainable capacity building, thereby, optimizing cost and efficiency.
                                                </p>
                                            </li>
                                        </ul>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="pt-7 pt-md-10">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="card card-row shadow-light-lg mb-6 lift lift-lg" id="farmcare">
                            <div class="row no-gutters">
                                <a class="col-12 col-md-6 bg-cover card-img-left farmcare" href="#!">
                                    <img alt="..." class="img-fluid d-md-none invisible" src="../../assets/img/1b.png">
                                    <div class="shape shape-right shape-fluid-y svg-shim text-white d-none d-md-block">
                                        <svg fill="none" viewBox="0 0 112 690" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M116 0H51V172C76 384 0 517 0 517V690H116V0Z" fill="currentColor"/>
                                        </svg>
                                    </div>
                                </a>
                                <div class="col-12 col-md-6 order-md-1">
                                    <a class="card-body tab-body" href="#!">
                                        <h2 class="font-weight-bold">
                                            Farm Care
                                        </h2>
                                        <ul class="list-unstyled mb-7">
                                            <li class="d-flex">
                                                <div class="badge badge-rounded-circle badge-success-soft mt-1 mr-4">
                                                    <i class="fe fe-check"></i>
                                                </div>
                                                <p>
                                                    The Farm Care module aims to make the farms productive, transparent and conflict-free.
                                                </p>
                                            </li>
                                            <li class="d-flex">
                                                <div class="badge badge-rounded-circle badge-success-soft mt-1 mr-4">
                                                    <i class="fe fe-check"></i>
                                                </div>
                                                <p>
                                                    Maintenance of identity registry, production and regulatory records.
                                                </p>
                                            </li>
                                            <li class="d-flex">
                                                <div class="badge badge-rounded-circle badge-success-soft mt-1 mr-4">
                                                    <i class="fe fe-check"></i>
                                                </div>
                                                <p>
                                                    Geo tagging of field mapping & farm assets to enhance accountability and accurate prediction.
                                                </p>
                                            </li>
                                            <li class="d-flex">
                                                <div class="badge badge-rounded-circle badge-success-soft mt-1 mr-4">
                                                    <i class="fe fe-check"></i>
                                                </div>
                                                <p>
                                                    Farm input management, Crop planning, Harvest & yield tracking and reporting to easily identify trends that produce the best results.
                                                </p>
                                            </li>
                                        </ul>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="pt-7 pt-md-10">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="card card-row shadow-light-lg mb-6 lift lift-lg" id="trace">
                            <div class="row no-gutters">
                                <a class="col-12 col-md-6 order-md-2 bg-cover card-img-right trace" href="#!">
                                    <img alt="..." class="img-fluid d-md-none invisible" src="../../assets/img/1a.png">
                                    <div class="shape shape-left shape-fluid-y svg-shim text-white d-none d-md-block">
                                        <svg fill="none" viewBox="0 0 112 690" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.14577e-06 0H62.7586V172C38.6207 384 112 517 112 517V690H2.14577e-06V0Z" fill="currentColor"/>
                                        </svg>
                                    </div>
                                </a>
                                <div class="col-12 col-md-6 order-md-1">
                                    <a class="card-body tab-body" href="#!">
                                        <h2 class="font-weight-bold">
                                            TruVito Trace
                                        </h2>
                                        <ul class="list-unstyled mb-7">
                                            <li class="d-flex">
                                                <div class="badge badge-rounded-circle badge-success-soft mt-1 mr-4">
                                                    <i class="fe fe-check"></i>
                                                </div>
                                                <p>
                                                    Customizable traceability platform to track journey of certified produce from farm to fork; Can be configured across multiple products and production process.
                                                </p>
                                            </li>
                                            <li class="d-flex">
                                                <div class="badge badge-rounded-circle badge-success-soft mt-1 mr-4">
                                                    <i class="fe fe-check"></i>
                                                </div>
                                                <p>
                                                    Provides supply chain transparency, promotes ethical sourcing.
                                                </p>
                                            </li>
                                            <li class="d-flex">
                                                <div class="badge badge-rounded-circle badge-success-soft mt-1 mr-4">
                                                    <i class="fe fe-check"></i>
                                                </div>
                                                <p>
                                                    Facilitates producers to grow sustainably & create trustworthy provenance that can be shared with stakeholders.
                                                </p>
                                            </li>
                                            <li class="d-flex">
                                                <div class="badge badge-rounded-circle badge-success-soft mt-1 mr-4">
                                                    <i class="fe fe-check"></i>
                                                </div>
                                                <p>
                                                    Helps Producers trace products based on batch numbers during product recalls, grievance redressal and complaints.
                                                </p>
                                            </li>
                                        </ul>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="pt-8 pb-5 pt-md-11 pb-md-11">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12 col-md">
                        <h3 class="font-weight-bold mb-1">
                            Interested in learning more about our products?
                        </h3>
                        <p class="font-size-lg text-muted mb-5 mb-md-0">
                            Hit us up and we'll get in touch with you.
                        </p>
                    </div>
                    <div class="col-12 col-md-auto">
                        <router-link :to="{name: 'salesenquiry'}" class="btn btn-success lift" @click.native="backToTop">
                            Send a note
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "Products",
        props: ["id"],
        mounted() {
            document.querySelector('#' + this.id).scrollIntoView({behavior: 'smooth'});
        },
        watch: {
            id: function() {
                document.querySelector('#' + this.id).scrollIntoView({behavior: 'smooth'});
            }
        },
        methods: {
            backToTop(event) {
                event.preventDefault();
                $("html, body").animate({scrollTop: 0}, "slow");
                return false;
            }
        }
    }
</script>

<style scoped>
    .truvito {
        background-image: url(../../assets/img/screen_1.jpg);
        background-size: auto;
    }

    .farmcare {
        /*background-image: url(../../assets/img/farm_care.jpg);*/
        background-image: url(../../assets/img/screen_2.jpg);
        background-size: auto;
    }

    .trace {
        /*background-image: url(../../assets/img/TruVito-Trace.jpg);*/
        background-image: url(../../assets/img/screen_3.jpg);
        background-size: auto;
    }

    @media (max-width: 768px) {
        .truvito {
            background-image: url(../../assets/img/screen_1.jpg);
            background-size: cover;
            font-size: 1rem;
        }

        .farmcare {
            /*background-image: url(../../assets/img/farm_care.jpg);*/
            background-image: url(../../assets/img/screen_2.jpg);
            background-size: cover;
        }

        .trace {
            /*background-image: url(../../assets/img/TruVito-Trace.jpg);*/
            background-image: url(../../assets/img/screen_3.jpg);
            background-size: cover;
        }

        .tab-body {
            font-size: 0.7rem !important;
        }
    }

    /*Need to chnage new resized picture for mobile screens*/

    @media (max-width: 425px) {
        .truvito {
            background-image: url(../../assets/img/1c.png);
            background-size: contain;
        }

        .farmcare {
            /*background-image: url(../../assets/img/farm_care.jpg);*/
            background-image: url(../../assets/img/1b.png);
            background-size: contain;
        }

        .trace {
            /*background-image: url(../../assets/img/TruVito-Trace.jpg);*/
            background-image: url(../../assets/img/1a.png);
            background-size: contain;
        }
    }

    .product-card {
        padding: 1.9rem 2.5rem;
    }

    .font-1rem {
        font-size: 0.9rem;
    }
</style>